import type { RJSFSchema } from '@rjsf/utils';

import { property as propertyGlobals } from '@luxuryescapes/lib-global';

import { PROPERTY_CHANNEL_MANAGERS } from '~/consts/reservation';

export default function preparePropertyFormSchema(
  schema: RJSFSchema | undefined,
  property: Record<string, unknown>,
): RJSFSchema | undefined {
  if (!schema) {
    return schema;
  }

  const properties = { ...(schema.properties ?? {}) };
  const propertySchema = { ...schema, properties };

  if (properties.max_child_age && typeof properties.max_child_age === 'object') {
    properties.max_child_age = { ...properties.max_child_age, minimum: 1 };
  }

  // Do not display status for non-rental properties
  if (property.type === propertyGlobals.HOTEL_TYPE) {
    delete properties.status;
  }

  if (property.channel_manager === PROPERTY_CHANNEL_MANAGERS.rentalsunited) {
    delete properties.logo_id_cloudinary_external;
  }

  return propertySchema;
}
